// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__34H8h","checkmark":"Checkbox_checkmark__211lQ"};